// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_ag-0";
export var orangeButton = "_ag-1";